import * as React from "react"
import { DrawerSeeker } from "@ui-seeker/core"

import AdminSkuDrawerContent from "./Content"
import { useAdminSkuForm } from "../@hooks"
import { adminSkuDrawerTitle, adminSkuFormData, disabledAdminSkuForm, isOpenDrawerAdminSku } from "../@signals"


export default function AdminSkuDrawer() {
    const { isLoading, handleSubmit } = useAdminSkuForm()

    return <DrawerSeeker
        disableCloseOnSuccess
        width="50%"
        isOpen={isOpenDrawerAdminSku.value}
        controller={() => adminSkuFormData.value = {}}
        title={adminSkuDrawerTitle.value}
        successProps={{
            disabled: disabledAdminSkuForm.value,
            loading: isLoading,
            onClick: handleSubmit
        }}
    >
        <AdminSkuDrawerContent />
    </DrawerSeeker>
}